export const ADMIN_PROFILE_UPDATED = 'sales-crm-admin-updated';

export function notifyAdminProfileUpdated() {
  window.dispatchEvent(new Event(ADMIN_PROFILE_UPDATED));
}
